import type { TerraUIMessage } from '@terra/shared-dto-chat-types';
import { extractPendingAskUserInteraction } from './message-processing';
import { computeHasPendingHITL } from './pending-hitl';

export const hasPendingChatConfirmation = (
  messages: TerraUIMessage[],
): boolean => {
  if (computeHasPendingHITL(messages)) {
    return true;
  }

  const askUser = extractPendingAskUserInteraction(messages);

  return askUser !== null && askUser.selectedValue === undefined;
};
